import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { NgClickOutsideDirective } from "ng-click-outside2";

import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { MessageService } from "../../../services/messageservice";

@Component({
  selector: "completer-location",
  templateUrl: "completer-location.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, NgClickOutsideDirective, FormsModule, TranslatePipe],
})
export class CompleterLocationComponent {
  private msgsrv = inject(MessageService);

  protected locations = input.required<string[]>();

  protected location = signal("");
  protected selectedLocations = signal<string[]>([]);
  protected searchActive = signal(false);

  protected uniqueLocations = computed(() => this.locations().filter((v, i, s) => s.indexOf(v) === i));
  protected searchResults = computed(() => {
    const needle = this.location().toLowerCase();
    return this.uniqueLocations().filter((location) => location.includes(needle));
  });

  protected handleCheck(target: EventTarget | null) {
    if (!(target instanceof HTMLInputElement)) return;
    if (target.checked) {
      this.addLocation(target.value);
    } else {
      this.removeLocation(target.value);
    }
  }

  protected isLocationFiltered(loc: string) {
    return this.selectedLocations().includes(loc);
  }

  protected addLocation(loc: string) {
    this.msgsrv.enableFilter({ type: "location", value: loc });
    if (!this.selectedLocations().includes(loc)) {
      this.selectedLocations.update((locs) => [...locs, loc]);
    }
  }

  protected removeLocation(loc: string) {
    this.msgsrv.disableFilter({ type: "location", value: loc });
    this.selectedLocations.update((locs) => locs.filter((l) => l !== loc));
  }

  protected onClickedOutside() {
    if (this.searchActive()) {
      this.searchActive.set(false);
    }
  }

  protected searchIsActive() {
    this.searchActive.set(true);
  }
}
